import React, { useEffect } from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { responseLogWithNotification } from '../../../utils/utils';
import Loader from '../../../components/base/Loader/Loader';
import { Button, Icons, Row } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { clearGlobalPopUpWrapper } from '../actions';
import { POPUP_LIST_NAME, USER_TYPE } from '../../../configs';
import {
  dateFormatter,
  getLegalEntityName,
  infoFormatter,
  infoFormatterIntl,
  localeFormatter, userFIOFormatter,
} from '../../../utils/formatters';
import { loadApplicantById } from '../../Applicant/actions';
import { getApplicantData } from '../../Applicant/reducer';

export default function DictCarrierDetailsPopUp(props) {
  const {
    id,
  } = props;
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const {
    currentApplicant = {},
    loadingCurrentApplicant,
  } = useSelector(getApplicantData);

  const {
    formMeta = {},
  } = currentApplicant;

  useEffect(() => {
    dispatch(loadApplicantById(id)).catch(responseLogWithNotification);
  }, [id]);

  return (
    <div className={classNames('full-view custom-scroll-theme')}>
      <Loader loading={loadingCurrentApplicant} />
      <div className="full-view-header">
        <div>{formatMessage({ id: 'driver.card.menu.carrier.details' })}</div>
        <Icons onClick={() => dispatch((clearGlobalPopUpWrapper({ key: POPUP_LIST_NAME.DICT_CARRIER_DETAIL, id })))} customIcon icon="close" />
      </div>
      <div className="full-view-content">
        <Row className="row-cols-1">
          {infoFormatterIntl('legal_entity_type', localeFormatter('user.type', currentApplicant?.legal_entity_type), {}, 'applicant.legal_entity_type')}
        </Row>
        {Number(currentApplicant?.legal_entity_type) === USER_TYPE.LEGAL ? (
          <>
            <Row className="row-cols-2">
              {infoFormatterIntl('legal_entity_form', currentApplicant?.legal_entity_form, formMeta, 'legal_entity_form')}
              {infoFormatterIntl('short_name_legal', currentApplicant?.short_name, formMeta, 'short_name')}
            </Row>
            <Row className="row-cols-1">
              {infoFormatterIntl('full_name_legal', getLegalEntityName({
                legal_entity_type: Number(currentApplicant?.legal_entity_type),
                short_name: currentApplicant?.short_name,
              }), formMeta, 'full_name')}
            </Row>
            <Row className="row-cols-1">
              {infoFormatterIntl('address', currentApplicant?.address, formMeta, 'address')}
            </Row>
            <Row className="row-cols-1">
              {infoFormatterIntl('legal_address', currentApplicant?.legal_address, formMeta, 'legal_address')}
            </Row>
            <Row className="row-cols-2">
              {infoFormatterIntl('inn', currentApplicant?.inn, formMeta, 'inn')}
              {infoFormatterIntl('ogrn', currentApplicant?.ogrn, formMeta, 'ogrn')}
            </Row>
            <Row className="row-cols-2">
              {infoFormatter('ФИО руководителя', userFIOFormatter(currentApplicant), formMeta, ['supervisor_last_name', 'supervisor_first_name', 'supervisor_middle_name'])}
            </Row>
            <Row className="row-cols-2">
              {infoFormatterIntl('phone', currentApplicant?.phone, formMeta, 'phone')}
              {infoFormatterIntl('pd.email', currentApplicant?.email, formMeta, 'email')}
            </Row>
          </>
        ) : (
          <>
            <Row className={Number(currentApplicant?.legal_entity_type) === USER_TYPE.INDIVIDUAL_ENTREPRENEUR ? 'row-cols-2' : 'row-cols-1'}>
              {infoFormatterIntl('inn', currentApplicant?.inn, formMeta, 'inn')}
              {Number(currentApplicant?.legal_entity_type) === USER_TYPE.INDIVIDUAL_ENTREPRENEUR ? infoFormatterIntl('ogrnip', currentApplicant?.ogrn, formMeta, 'ogrn') : null}
            </Row>
            <Row className="row-cols-1">
              {infoFormatterIntl('ФИО', getLegalEntityName({
                legal_entity_type: Number(currentApplicant?.legal_entity_type),
                last_name: currentApplicant?.last_name,
                first_name: currentApplicant?.first_name,
                middle_name: currentApplicant?.middle_name,
              }), formMeta, 'full_name')}
            </Row>
            <Row className="row-cols-2">
              {infoFormatterIntl('birth_date', dateFormatter(currentApplicant?.birth_date), formMeta, 'birth_date')}
              {infoFormatterIntl('place_of_birth', currentApplicant?.birth_place, formMeta, 'place_of_birth')}
            </Row>
            <Row className="row-cols-2">
              {infoFormatterIntl('gender', formatMessage({ id: `gender.${currentApplicant?.gender}`, defaultMessage: currentApplicant?.gender || ' ' }), formMeta, 'gender')}
              {infoFormatterIntl('citizenship', formatMessage({ id: `citizenship.legal_entity_type.${currentApplicant?.citizenship}`, defaultMessage: currentApplicant?.citizenship || ' ' }), formMeta, 'citizenship')}
            </Row>
            <Row className="row-cols-2">
              {infoFormatterIntl('snils', currentApplicant?.snils, formMeta, 'snils')}
              {infoFormatterIntl('registration_type', formatMessage({ id: `registration.legal_entity_type.${currentApplicant?.reg_type}`, defaultMessage: currentApplicant?.reg_type || ' ' }), formMeta, 'registration_type')}
            </Row>
            <Row className="row-cols-2">
              {infoFormatterIntl('phone', currentApplicant?.phone, formMeta, 'phone')}
              {infoFormatterIntl('pd.email', currentApplicant?.email, formMeta, 'email')}
            </Row>
            <Row className="row-cols-2">
              {infoFormatterIntl('identity_type_short', formatMessage({ id: `identity.legal_entity_type.${currentApplicant?.identity_type}`, defaultMessage: currentApplicant?.identity_type || ' ' }), formMeta, 'identity_type')}
              {infoFormatterIntl('identity_issue_date', dateFormatter(currentApplicant?.identity_issue_date), formMeta, 'identity_issue_date')}
            </Row>
            <Row className="row-cols-2">
              {infoFormatterIntl('identity_series', currentApplicant?.identity_series, formMeta, 'identity_series')}
              {infoFormatterIntl('identity_number', currentApplicant?.identity_number, formMeta, 'identity_number')}
            </Row>
            <Row className="row-cols-2">
              {infoFormatterIntl('identity_issuer_code', currentApplicant?.identity_issuer_code, formMeta, 'identity_issuer_code')}
              {infoFormatterIntl('criminal_record_certificate_info_doc', currentApplicant?.criminal_record, formMeta, 'criminal_record_certificate_info_doc')}
            </Row>
            <Row className="row-cols-1">
              {infoFormatterIntl('identity_issuer', currentApplicant?.identity_issuer, formMeta, 'identity_issuer')}
            </Row>
            {
                  Number(currentApplicant?.legal_entity_type) === USER_TYPE.INDIVIDUAL_ENTREPRENEUR
                    ? (
                      <Row className="row-cols-2">
                        {infoFormatterIntl('address', currentApplicant?.office_address, formMeta, 'office_address')}
                        {infoFormatterIntl('address_registration_entrepreneur', currentApplicant?.address, formMeta, 'address')}
                      </Row>
                    ) : (
                      <Row className="row-cols-1">
                        {infoFormatterIntl('registration_address', currentApplicant?.address, formMeta, 'address')}
                      </Row>
                    )
                }
          </>
        )}
      </div>
      {/* <div className="full-view-footer"> */}
      {/*  <Button variant="primary"> */}
      {/*    {formatMessage({ id: 'return_registry_carrier' })} */}
      {/*  </Button> */}
      {/* </div> */}
    </div>
  );
}
